export const restrictionResources = {
  'restriction.box': 'Boxes',
  'restriction.envelope': 'Envelopes',
  'restriction.max_combined': 'length + width + height',
  'restriction.max_volume': 'volume',
  'restriction.max_length': 'length',
  'restriction.in': 'inches',
  'restriction.cm': 'centimeters',
  'restriction.max': 'maximum',
  'restriction.lb': 'pounds',
  'restriction.kg': 'kilograms',
  'restriction.weight_title': 'Weight Restrictions',
  'restriction.dimension_title': 'Dimension Restrictions',
  'restriction.must_have': 'must have a',
  'restriction.have_a': 'have a',
  'restriction.weight_of': 'weight of',
  'restriction.weight_of_less': 'weight of less than',
  'restriction.weight_of_more': 'weight of more than',
  'restriction.less_than': 'less than',
  'restriction.more_than': 'more than',
  'restriction.volume': 'volume',
  'restriction.length': 'length',
  'restriction.combined': 'combined dimensions',
  // used my entire liberal arts education to figure out
  // how to phrase this in a way I could keep everything else in place
  'restriction.dimensions': 'set of dimensions where each respective side is',
  'restriction.weight_floor': 'costed weight of at least',
};

export type RestrictionResourceKey = keyof typeof restrictionResources;
